
    <div class="cm-global-spinner-background">
      <div class="cm-global-spinner">
        <mat-spinner [color]="'primary'" [mode]="'indeterminate'"></mat-spinner>
      </div>
    </div>